import React from 'react';
import { Eye, EyeOff, FolderInput, Trash2, X } from 'lucide-react';
import { Button } from '../ui/button';

export const PlannerSelectionToolbar = ({ count, disabled, onAction, onClear }) => <div data-testid="planner-selection-toolbar" className="border-y border-gray-200 py-3 mb-4 space-y-3">
  <div className="flex items-center justify-between gap-2">
    <span data-testid="planner-selected-count" className="text-sm font-semibold">{count} seleccionados</span>
    <Button data-testid="planner-selection-clear" size="sm" variant="ghost" disabled={!count} onClick={onClear}><X size={14} className="mr-1" /> Limpiar</Button>
  </div>
  <div className="flex flex-wrap gap-2">
    {[
      ['hide', 'Ocultar', EyeOff], ['show', 'Mostrar', Eye], ['move', 'Mover', FolderInput], ['delete', 'Eliminar de la app', Trash2],
    ].map(([action, label, Icon]) => <Button key={action} data-testid={`planner-bulk-${action}`} size="sm" variant="outline" disabled={!count || disabled} className={action === 'delete' ? 'text-red-700 border-red-200' : ''} onClick={() => onAction(action)}><Icon size={14} className="mr-1.5" />{label}</Button>)}
  </div>
  {disabled && <p data-testid="planner-unsaved-notice" className="text-xs text-amber-800">Guarda el orden pendiente antes de aplicar acciones a los archivos.</p>}
</div>;